import { render, staticRenderFns } from "./TebaEmailDialog.vue?vue&type=template&id=352219f2&scoped=true"
import script from "./TebaEmailDialog.vue?vue&type=script&lang=js"
export * from "./TebaEmailDialog.vue?vue&type=script&lang=js"
import style0 from "./TebaEmailDialog.vue?vue&type=style&index=0&id=352219f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352219f2",
  null
  
)

export default component.exports